import { render, staticRenderFns } from "./deptHarmfulFactorsDetail.vue?vue&type=template&id=3bba035c"
import script from "./deptHarmfulFactorsDetail.vue?vue&type=script&lang=js"
export * from "./deptHarmfulFactorsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bba035c')) {
      api.createRecord('3bba035c', component.options)
    } else {
      api.reload('3bba035c', component.options)
    }
    module.hot.accept("./deptHarmfulFactorsDetail.vue?vue&type=template&id=3bba035c", function () {
      api.rerender('3bba035c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/wmr/deptHarmfulFactorsDetail.vue"
export default component.exports